import { Col, Row } from "react-bootstrap";
import { Fragment } from "react/jsx-runtime";
import { AbccAssessment, AbccAssessmentModule, AbccAssessmentStatus } from "../Models/CCAssessment";
import CCAbccAssessmentModuleSummary from "./CCAbccAssessmentModuleSummary";
import { getDateWithOffset } from "../../../Shared/Utility/GetDateWithOffset";
import { ExaminationGrade } from "../../../Examination/Enums/ExaminationGrade";

interface IProps{
    abccAssessment: AbccAssessment;
    acceptAbccModuleAttestation: (abccAssessmentModule: AbccAssessmentModule) => void;
}

export default function CCAbccAssessmentSummary(props: IProps){

    const abccAssessmentStartDate = getDateWithOffset(props.abccAssessment.startDate);
    const abccAssessmentEndDate = getDateWithOffset(props.abccAssessment.endDate);

    const displayAssessmentPassedSummary = () => {
        return (<div className="ccassessment-module-evaluation-pass">
            You have passed this assessment. No further assessment requirement through {abccAssessmentEndDate.toLocaleDateString('en-US')}
        </div>)
    }

    const displayAssessmentProvisionalPassSummary = () => {
        return (<div className="ccassessment-module-evaluation-provisional-pass">
            You have passed all modules of this assessment. No further assessment requirement through {abccAssessmentEndDate.toLocaleDateString('en-US')}
        </div>)
    }

    const displayAssessmentFailedSummary = () => {
        return (<div className="ccassessment-module-evaluation-fail">
            This assessment attempt was not successful. You will be need to transition to the exam pathway and pass a CC/recertification exam before the end of  {abccAssessmentEndDate.toLocaleDateString('en-US')}
        </div>)
    }

    const displayAssessmentNeutralSummary = () => {
        return (<div className="ccassessment-module-evaluation-neutral">
            Once you have passed all remaining modules of this assessment, no further assessment requirement will be required through {abccAssessmentEndDate.toLocaleDateString('en-US')}
        </div>)
    }

    const displayEvaulationSummary = () => {
        // Pass - Grade = 1
        if (props.abccAssessment.grade == ExaminationGrade.Pass || props.abccAssessment.abccAssessmentStatusId == AbccAssessmentStatus.GradingComplete){
            return displayAssessmentPassedSummary();
        }

        // Provisional Pass = all modules passed but grade not set yet
        let allModulesPassed = props.abccAssessment.modules.every(module => module.grade == ExaminationGrade.Pass);
        let numFailed = props.abccAssessment.modules.filter(module => module.grade == ExaminationGrade.Fail).length;
        var hasPassedCatchupModule = props.abccAssessment.modules.some(module => module.grade == ExaminationGrade.Pass && module.isCatchUp);


        if ((allModulesPassed && !props.abccAssessment.isMissingModule) // has legitimately passed all modules
            || hasPassedCatchupModule && numFailed < 2) // has passed all modules with help of a catchup module
            {
                return displayAssessmentProvisionalPassSummary();
            } 
        

        // Fail - will be transitioned to exam pathway in end date
        var failedModules = props.abccAssessment.modules.filter(module => module.grade == ExaminationGrade.Fail);
        var mostRecentFailedModule = failedModules.sort((a, b) => getDateWithOffset(b.endDate).getTime() - getDateWithOffset(a.endDate).getTime())[0];

        let failedModuleAndLessThan3YearsRemain = false;
        if (mostRecentFailedModule != null) {
            let abccAssessmentEndDate = getDateWithOffset(props.abccAssessment.endDate);
            let mostRecentFailedModuleEndDate = getDateWithOffset(mostRecentFailedModule.endDate);
            let yearsSinceMostRecentFailedModule = (abccAssessmentEndDate.getFullYear() - mostRecentFailedModuleEndDate.getFullYear());
            failedModuleAndLessThan3YearsRemain = yearsSinceMostRecentFailedModule < 3;
        }

        
        


        if (props.abccAssessment.grade == ExaminationGrade.Fail 
            || (mostRecentFailedModule && failedModuleAndLessThan3YearsRemain)) { 
            return displayAssessmentFailedSummary();
        }

        // Neutral
        return displayAssessmentNeutralSummary();
    }

    
    return (<Fragment>
        <Row className="ccassessment-pathway-title">
            <Col>
                <div className="font-weight-bolder card-title h5"><span>Article Based Continuing Certification (ABCC) Pathway</span></div>
            </Col>
        </Row>
        <Row>
            <Col>
                <Row className="ccassessment-module-detail">
                    <Col>
                        {props.abccAssessment.modules.map(module => {
                            return(<CCAbccAssessmentModuleSummary abccAssessmentModule={module} acceptAttestation={props.acceptAbccModuleAttestation} />)
                        })}
                    </Col>
                </Row>
                <Row className="ccassessment-module-detail">
                    <Col>
                        {displayEvaulationSummary()}
                    </Col>
                </Row>
            </Col>
        </Row>

    </Fragment>)
}